const es = {
  // Landing
  landingHeroTitle: "Detecta follows sospechosos. Deja de adivinar.",
  landingHeroSubtitle: "Mira a quién sigue tu pareja, crush o amigos recientemente. Recibe alertas de nuevos follows y unfollows. 100% anónimo.",
  landingHeroPlaceholder: "Ingresa el @usuario para analizar",
  landingHeroCta: "Analizar perfil",
  landingHowItWorks: "Cómo funciona",
  landingStep1Title: "Ingresa el usuario",
  landingStep1Body: "Escribe el perfil de Instagram que deseas analizar.",
  landingStep2Title: "Rastreamos nuevos follows",
  landingStep2Body: "Nuestro sistema mapea las conexiones más recientes y lo organiza todo en una línea de tiempo limpia.",
  landingStep3Title: "Recibe alertas de cambios",
  landingStep3Body: "Entérate de inmediato cada vez que el perfil siga o deje de seguir a alguien.",
  landingComparisonTitle: "Chequeo manual vs. Monitoreo automático",
  landingComparisonManual: "Chequeo manual",
  landingComparisonManualDesc: "Abre Instagram, busca el perfil, desplázate por su lista de seguidos intentando recordar quién es nuevo.",
  landingComparisonAutomated: "Monitoreo Stalkie",
  landingComparisonAutomatedDesc: "Detectamos cambios automáticamente. Nuevos follows, unfollows y cambios en la lista de seguidos.",
  landingReliabilityTitle: "¿Cómo funciona la recolección de datos?",
  landingReliabilityBody: "Consultamos datos para rastrear cambios en los perfiles. Aunque buscamos precisión, ten en cuenta las reglas del servicio:",
  landingReliability1: "Usamos peticiones seguras para actualizar la línea de tiempo",
  landingReliability2: "No es posible rastrear perfiles privados",
  landingReliability3: "Las actualizaciones en la plataforma pueden influir en la frecuencia de chequeo",
  landingReliability4: "Solo mostramos los follows y unfollows nuevos detectados a partir del inicio",
  landingReliabilityCta: "Garantizamos total anonimato: el perfil objetivo nunca sabrá que lo estás verificando.",
  landingFaqTitle: "Preguntas frecuentes",
  landingFaq1Q: "¿Necesito iniciar sesión en mi Instagram?",
  landingFaq1A: "No. Stalkie funciona de manera 100% anónima e independiente. Nunca necesitas proporcionar tu contraseña ni conectar tu cuenta.",
  landingFaq2Q: "¿Puedo monitorear cuentas privadas?",
  landingFaq2A: "No. Solo rastreamos perfiles públicos de Instagram. Los perfiles privados no pueden ser monitoreados y respetamos la configuración de privacidad de Instagram.",
  landingFaq3Q: "¿Con qué frecuencia se actualizan los datos?",
  landingFaq3A: "Chequeamos el perfil regularmente según el plan de suscripción seleccionado y enviamos alertas de cambios.",
  landingFaq4Q: "¿Veré el historial de follows antes del monitoreo?",
  landingFaq4A: "Mostramos los follows actuales. El historial y las alertas de nuevas conexiones comienzan a generarse a partir de que se activa el rastreo.",
  landingFaq5Q: "¿El perfil objetivo sabrá que lo estoy observando?",
  landingFaq5A: "No. El monitoreo se realiza de forma totalmente anónima desde nuestros servidores. No se envía ninguna notificación al perfil verificado.",
  landingCtaTitle: "¿Quieres saber la verdad?",
  landingCtaBody: "Ingresa el @usuario abajo para revelar las últimas conexiones y nuevos follows.",
  landingDisclaimer: "Stalkie es un servicio de monitoreo independiente y no tiene afiliación ni patrocinio con Instagram o Meta.",

  // Search
  searchTitle: "Rastreando conexiones",
  searchSubtitle: "Verificando historial reciente de @%{handle}",
  previewAnalyzingTitle: "Analizando follows",
  previewProgressLabel: "Progreso",
  searchLoading1: "Preparando conexión segura...",
  searchLoading2: "Localizando perfil...",
  searchLoading3: "Analizando perfil...",
  searchLoading4: "Creando tu reporte...",
  searchLoading5: "Finalizando vista segura...",
  searchErrorInvalid: "Usuario inválido. Usa letras, números, guiones bajos y puntos.",
  searchErrorEmpty: "Por favor, ingresa un usuario de Instagram.",
  searchErrorProvider: "Nuestro proveedor de datos no está disponible. Intenta de nuevo más tarde.",
  searchErrorRateLimit: "Demasiadas solicitudes. Espera un momento e inténtalo de nuevo.",
  searchErrorNotFound: "Perfil no encontrado. Verifica el nombre e inténtalo de nuevo.",
  searchErrorGeneric: "Algo salió mal. Inténtalo de nuevo.",
  validationEmpty: "Por favor, ingresa un usuario de Instagram.",
  validationInvalidProviderUrl: "Usa un enlace de perfil de instagram.com o un nombre de usuario.",
  validationInvalidUrl: "Usa un enlace de perfil de Instagram o un nombre de usuario válido.",
  validationSpacesOrAt: "Los nombres de usuario no pueden contener espacios ni símbolos @ adicionales.",
  validationLengthOrChars: "Usa entre 1 y 30 letras, números, guiones bajos o puntos.",
  downloadIos: "Descargar para iOS",
  downloadAndroid: "Descargar para Android",
  scanToDownload: "Escanea para descargar",

  // Profile preview
  previewTitle: "@%{handle}",
  previewPublicAvailable: "Perfil disponible — Rastreo listo",
  previewPrivateNotAvailable: "Perfil privado — no se puede monitorear",
  previewNotFound: "Perfil no encontrado",
  previewPrivateNote: "A diferencia de otras aplicaciones, Stalkie no accede a cuentas privadas de Instagram, y esto es por diseño.",
  previewNotFoundBody: "Verifica la ortografía del usuario e inténtalo de nuevo. Asegúrate de que sea un nombre de usuario de Instagram válido.",
  previewFollowingCount: "%{count} siguiendo",
  previewFollowersCount: "%{count} seguidores",
  previewVerified: "Verificado",
  previewLastChecked: "Última verificación: %{time}",
  previewReliabilityLabel: "Confianza de datos: %{level}",
  previewBaselineTitle: "Conexiones recientes",
  previewBaselineBody: "Estos son algunos de los perfiles que el usuario sigue actualmente.",
  previewLockedTitle: "Desbloquear monitoreo de follows",
  previewLockedBody: "Suscríbete para monitorear este perfil. Recibirás alertas en tu teléfono cada vez que siga o deje de seguir a alguien.",
  previewLockedCta: "Ver planes",
  previewNoDataTitle: "Sin datos disponibles",
  previewNoDataBody: "No pudimos obtener datos para este perfil. Puede ser privado o estar temporalmente no disponible.",
  previewWhatYouGet: "Lo que obtienes con el monitoreo:",
  previewFeature1: "Detección automática de nuevos follows",
  previewFeature2: "Detección automática de unfollows",
  previewFeature3: "Línea de tiempo organizada por fecha",
  previewFeature4: "Alertas automáticas de cambios",
  previewFeature5: "Análisis de género de los nuevos follows",
  previewMonitoringStartsAfter: "El seguimiento histórico comienza después de iniciar el monitoreo. Los cambios pasados no están disponibles.",
  previewWhatDoYouThink: "¿Qué opinas? 🤔",
  previewRecentlyFollowed: "%{name} siguió recientemente",
  previewGirlsCount: "%{count} chicas",
  previewGirlCount: "%{count} chica",
  previewGuysCount: "%{count} chicos",
  previewGuyCount: "%{count} chico",
  previewOthersCount: "%{count} otros",
  previewOtherCount: "%{count} otro",
  previewUnlockNow: "Desbloquear ahora",
  previewAuthenticatedTitle: "Listo para monitorear",
  previewAuthenticatedBody: "Agrega este perfil a tu monitoreo y recibe alertas cuando haya cambios.",
  previewAddMonitoring: "Agregar monitoreo",
  previewContinueToReview: "Continuar",
  searchPageKicker: "Vista previa de perfil público",
  searchPageSubtitle: "Busca cualquier usuario público de Instagram para ver la disponibilidad del perfil antes de monitorearlo.",
  searchPageEnterHandle: "Ingresa un usuario para comenzar",
  searchPageEnterHandleDesc: "Usa la búsqueda de arriba para verificar un perfil público y ver una vista previa bloqueada.",
  searchPageValidating: "Validando @%{handle} antes de verificar los datos públicos.",
  previewingHandle: "Visualizando a @%{handle}",
  previewPageSubtitle: "Sigue buscando perfiles públicos y compara las vistas previas antes de suscribirte.",
  
  reliability_reliable: "Perfil disponible",
  reliability_reliable_desc: "Este perfil es público y está listo para ser monitoreado.",
  reliability_probably_reliable: "Perfil disponible",
  reliability_probably_reliable_desc: "Este perfil es público y está listo para ser monitoreado.",
  reliability_confirmation_required: "Verificando perfil",
  reliability_confirmation_required_desc: "Verificando el estado del perfil y las actualizaciones recientes.",
  reliability_degraded: "Perfil disponible",
  reliability_degraded_desc: "Este perfil es público y está listo para ser monitoreado.",
  reliability_incomplete_data: "Datos no disponibles",
  reliability_incomplete_data_desc: "No pudimos recuperar suficiente información para este perfil.",
  reliability_provider_error: "Temporalmente no disponible",
  reliability_provider_error_desc: "La búsqueda no está disponible temporalmente. Inténtalo de nuevo más tarde.",
  reliability_private_profile: "Perfil privado",
  reliability_private_profile_desc: "Este perfil es privado. Solo podemos monitorear perfiles públicos de Instagram.",
  reliability_paused_unreliable: "No disponible",
  reliability_paused_unreliable_desc: "El monitoreo no está disponible temporalmente.",
  reliability_unknown: "Verificando estado",
  reliability_unknown_desc: "Verificando el estado del perfil.",

  // Paywall
  paywallTitle: "Desbloquear monitoreo de @%{handle}",
  paywallSubtitle: "Recibe alertas en tiempo real cada vez que este perfil siga o deje de seguir a alguien.",
  paywallPlanWeekly: "Semanal",
  paywallPlanMonthly: "Mensal",
  paywallBestValue: "Mejor valor",
  paywallTitleTarget: "Sigue el rastro de @%{handle}",
  paywallSubtitleTarget: "Recibe alertas cuando @%{handle} siga a alguien nuevo. Nosotros seguimos monitoreando para que no tengas que verificar manualmente.",
  paywallProfilesFollowing: "Perfiles que sigue @%{handle}",
  paywallFeaturePrivateTitle: "100% privado y seguro",
  paywallFeaturePrivateDesc: "No requiere inicio de sesión de Instagram",
  paywallFeatureRecentTitle: "Ver nuevos follows en orden",
  paywallFeatureRecentDesc: "Mira exactamente a quién siguió el perfil, ordenado por fecha",
  paywallFeatureNotifiedTitle: "Alertas de cada cambio",
  paywallFeatureNotifiedDesc: "Notificaciones instantáneas de nuevos follows y unfollows",
  paywallTrusted: "Confiado por más de 1 millón de usuarios",
  paywallCancelAnytime: "Cancela en cualquier momento, sin compromisos",
  paywallNotNow: "Ahora no",
  paywallPlanWeeklyDesc: "Menor compromiso, acceso completo",
  paywallPlanMonthlyDesc: "Los mismos recursos, por más tiempo",
  paywallMonitorLimit: "Hasta %{count} perfiles",
  paywallCta: "Comenzar monitoreo",
  paywallRestore: "Restaurar compra",
  paywallRestoring: "Restaurando...",
  paywallRestoreSuccess: "Compra restaurada. Tu suscripción está activa.",
  paywallRestoreNotFound: "No se encontró ninguna compra activa para esta cuenta.",
  paywallRestoreError: "No se pudo restaurar la compra. Intenta de nuevo.",
  paywallTerms: "Al continuar, aceptas nuestros Términos de Uso y Política de Privacidad.",
  paywallBillingNote: "Cobro recurrente. Cancela cuando quieras.",
  paywallPerDay: "Menos de %{price} por día",

  paywallBillingPeriodWeekly: "semana",
  paywallBillingPeriodMonthly: "mes",
  paywallErrorStartMonitoring: "No se pudo iniciar el monitoreo. Intenta de nuevo.",
  paywallErrorLoad: "No se pudieron cargar los planes. Intenta de nuevo.",
  paywallActivatingPlan: "Activando tu plan...",
  paywallMonitorSetupFailedTitle: "El monitoreo no se inició",
  paywallMonitorSetupFailedBody: "Tu plan está activo, pero no pudimos iniciar el monitoreo de este perfil. Intenta de nuevo.",
  paywallProcessingPaymentTitle: "Procesando pago...",
  paywallProcessingPaymentBody: "Tu pago puede tardar unos instantes en procesarse. Si no eres redirigido, revisa el recibo en tu correo.",
  paywallSuccessTitle: "Todo listo",
  paywallSuccessBody: "Te llevamos a la vista general...",
  paywallSettingUpProfile: "Iniciando monitoreo de @%{handle}...",
  billingContinueInAppTitle: "Continúa en la app Stalkie",
  billingContinueInAppBody: "La búsqueda web verifica la disponibilidad del perfil. En la app Stalkie, puedes mantener el monitoreo y recibir alertas de follows y unfollows.",

  // Monitoring status
  monitoringActive: "Activo",
  monitoringPaused: "Pausado",
  monitoringPrivate: "Privado",
  monitoringRateLimited: "Limitado",
  monitoringDisabled: "Desactivado",
  monitoringPendingFirstSync: "Esperando primera sincronización",
  monitoringDegraded: "Degradado",
  monitoringError: "Error",
  monitoringNextUpdate: "Próxima actualización: %{time}",

  // Timeline events
  timelineStartedFollowing: "Empezó a seguir",
  timelineStoppedFollowing: "Dejó de seguir",
  timelineGainedFollower: "Nuevo seguidor",
  timelineLostFollower: "Perdió seguidor",
  timelinePendingConfirmation: "Confirmación pendiente",
  timelineLowConfidence: "Baja confianza",
  timelineDiscarded: "Descartado",
  timelineNoEvents: "Sin eventos aún",
  timelineNoEventsHint: "Los eventos aparecen aquí cuando el monitoreo detecta cambios.",
  timelineEventsRetention: "Los eventos se conservan hasta por 90 días.",
  timelineMonitoringStarted: "Monitoreo iniciado",
  timelineDataGap: "Brecha de datos — sin datos confiables en este período",

  // App shell
  appDashboard: "Vista general",
  appProfiles: "Perfiles",
  appTimeline: "Línea de tiempo",
  appBilling: "Suscripción",
  appAccount: "Configuración",
  appNotifications: "Notificaciones",
  notificationsEmptyTitle: "Todo está al día",
  notificationsEmptyBody: "La nueva actividad aparecerá aquí.",
  notificationsUnavailableTitle: "Las notificaciones no están disponibles temporalmente.",
  notificationsUnavailableBody:
    "Tu cuenta sigue segura. Vuelve al panel e inténtalo de nuevo en un momento.",
  notificationsBackToDashboard: "Volver al panel",
  settingsEmailNotifications: "Respaldo por email",
  settingsEmailNotificationsDesc: "Recibe un email si las notificaciones del navegador no están disponibles.",
  notificationsMarkAllRead: "Marcar todo como leído",
  appNavigation: "Navegación de la app",
  appSignOut: "Cerrar sesión",

  // Dashboard
  dashboardTitle: "Perfiles monitoreados",
  dashboardOverviewTitle: "Detecta follows sospechosos",
  dashboardEyebrow: "Alertas de follows",
  dashboardOverviewSubtitle: "Agrega un perfil público de Instagram para ver nuevos follows, unfollows y recibir alertas.",
  dashboardMonitoringChip: "Monitoreando",
  dashboardEmpty: "Detecta follows sospechosos. Deja de adivinar.",
  dashboardEmptyHint: "Agrega un perfil público de Instagram para monitorear nuevos follows y unfollows. 100% anónimo.",
  dashboardEmptyProof: "100% Anónimo",
  dashboardFeatureNewFollows: "Nuevos follows detectados",
  dashboardFeatureUnfollows: "Unfollows detectados",
  dashboardAddProfile: "Agregar perfil",
  dashboardAccountLimit: "%{current}/%{limit} perfiles",
  dashboardUpgradeCta: "Suscribirse para agregar más",
  renewalTitle: "Reactivar monitoreo",
  renewalDescription: "Tu plan anterior ya no está activo. Renueva para agregar perfiles y seguir recibiendo alertas.",
  renewalCta: "Renovar plan",
  onboardingTargetTitle: "¿Qué perfil quieres monitorear?",
  addTargetSubtitle: "Pega un usuario o enlace de perfil de Instagram. Stalkie solo monitorea perfiles públicos y empieza desde este momento.",
  addTargetModalTitle: "Confirmar",
  addTargetClipboardPaste: "Pegar @%{handle}",
  addTargetPrivateError: "Este perfil es privado. Stalkie solo monitorea perfiles públicos de Instagram.",
  loadingAddMonitorTitle: "Agregando perfil",
  loadingAddMonitorSubtitle: "Preparando monitoreo...",
  loadingAddMonitorStep1: "Verificando perfil",
  loadingAddMonitorStep2: "Iniciando monitoreo",
  loadingAddMonitorStep3: "Finalizando configuración",
  // Billing
  billingTitle: "Suscripción",
  billingCurrentPlan: "Plan actual",
  billingFree: "Gratis",
  billingManage: "Gestionar suscripción",
  billingExpiresAt: "Renueva o expira el %{date}",
  billingSignInTitle: "Entra para gestionar la suscripcion",
  billingSignInBody: "Crea una cuenta para suscribirte y empezar a monitorear perfiles.",
  billingNoSubscription: "Sin suscripción activa",
  billingCheckoutError: "No se pudo abrir la página de pago. Intenta de nuevo.",
  billingPortalError: "No se pudo abrir la gestión de suscripción. Intenta de nuevo.",
  billingRenewKicker: "Plan necesario",
  billingRenewTitle: "Mantén el monitoreo activo",
  billingRenewTitleTarget: "Empezar a monitorear @%{handle}",
  billingRenewBody: "Elige un plan para agregar perfiles, recibir alertas y mantener el monitoreo activo.",
  billingRenewBodyTarget: "Elige un plan para agregar @%{handle} y empezar a rastrear nuevos follows desde ahora.",
  billingRenewIntro: "El monitoreo solo está disponible con un plan activo. Tu cuenta queda lista; elige un plan para reactivar el seguimiento.",
  billingRenewIntroTarget: "Después del pago, @%{handle} entra directo en el monitoreo.",
  billingIncluded: "Incluido",
  billingFeatureAnonymous: "Monitoreo anónimo",
  billingFeatureAlerts: "Alertas de follows y unfollows",
  billingFeatureDirect: "Agregado directo del perfil",
  billingPlanWeeklyMeta: "Hasta %{count} perfiles, cobro semanal",
  billingPlanMonthlyMeta: "Hasta %{count} perfiles, cobro mensual",
  billingStartTarget: "Empezar @%{handle}",
  statusActive: "Activo",

  // Account
  accountTitle: "Cuenta",
  settingsTitle: "Configuración",
  settingsNotifications: "Notificaciones",
  settingsNotificationsDesc: "Recibir alertas de nuevos follows y unfollows",
  settingsSupport: "Soporte",
  settingsHelp: "Centro de ayuda",
  settingsReport: "Reportar un problema",
  settingsAbout: "Acerca de",
  settingsUserId: "ID de usuario",
  settingsVersion: "Versión",
  settingsLegal: "Legal",
  settingsTerms: "Términos de uso",
  settingsPrivacy: "Política de privacidad",
  settingsDeleteAccount: "Eliminar cuenta",
  settingsDeleteAccountDesc: "Esta acción es irreversible",
  settingsCopied: "Copiado",
  accountNotificationsSaved: "Preferencias de notificación actualizadas.",
  accountNotificationsError: "No se pudieron actualizar las notificaciones. Intenta de nuevo.",
  accountNotificationsBlocked: "Las notificaciones están bloqueadas por tu navegador. Actívalas en la configuración del navegador.",
  accountNotificationsNotSupported: "Este navegador no admite notificaciones push.",
  accountCopyError: "No se pudo copiar el ID en este navegador.",
  accountDeleteError: "No se pudo eliminar la cuenta. Intenta de nuevo o contacta soporte.",
  accountDeleteSubscriptionWarning: "Eliminar tu cuenta no cancela tu suscripción activa.",
  accountLanguage: "Idioma",
  accountLanguagePt: "Português",
  accountLanguageEn: "English",
  accountLanguageEs: "Español",
  accountSignInTitle: "Inicia sesión para administrar tu cuenta",
  accountSignInBody: "Crea una cuenta para comenzar.",
  accountSession: "Sesión",
  accountCreated: "Creado el %{date}",
  accountDeleteBtn: "Eliminar cuenta",
  accountDeleteConfirmText: "Esta acción es irreversible. Se eliminarán todos tus datos de monitoreo.",
  accountDeleteConfirmBtn: "Confirmar eliminación",
  accountCancel: "Cancelar",
  accountSubscriptionStatus: "Estado: %{status}",
  accountSubscriptionLimit: "Límite de perfiles: %{count}",

  // Dashboard Page additions
  dashboardErrorLoad: "Error al cargar los perfiles monitoreados.",
  dashboardSignInTitle: "Inicia sesión para ver tu panel",
  dashboardSignInBody: "Crea una cuenta para comenzar a monitorear perfiles.",

  // Profile Detail Page additions
  profileDetailRemoved: "Es posible que este perfil haya sido eliminado.",
  profileDetailRemoveBtn: "Eliminar monitoreo",
  tabFollows: "Nuevos follows",
  statNew: "Nuevos",
  tabUnfollows: "Unfollows",
  monitorDetailsMonitoringStarted: "Monitoreo activo",
  monitorDetailsMonitoringStartedHint: "Los nuevos follows aparecerán aquí cuando Stalkie detecte un cambio confiable.",
  monitorDetailsRecentActivity: "Actividad reciente",
  monitorDetailsPrivateWaiting: "Este perfil está privado ahora. Stalkie mantiene el monitoreo pausado hasta que la cuenta vuelva a ser pública.",
  monitorDetailsDeleteDescription: "Esto elimina el perfil de tu lista de monitoreo. Los datos existentes de este perfil serán eliminados.",
  monitorDetailsDeleteConfirm: "Eliminar",
  monitorDetailsDeleteError: "No se pudo eliminar este monitoreo. Intenta de nuevo.",
  emptyUnfollows: "Ningún unfollow detectado aún",
  activityHoursTitle: "Patrón de actividad",

  // Timeline Filter additions
  timelineFilterAll: "Todo",
  timelineFilterFollows: "Seguidos",
  timelineFilterUnfollows: "Dejados de seguir",

  // Common
  commonBack: "Volver",
  commonClose: "Cerrar",
  commonLoading: "Cargando...",
  commonError: "Algo salió mal",
  commonRetry: "Intentar de nuevo",
  commonLoadMore: "Cargar más",
  profileUpdatedAt: "Actualizado %{time}",
  commonNever: "nunca",
  commonJustNow: "justo ahora",
  commonMinutesAgo: "hace %{minutes}min",
  commonHoursAgo: "hace %{hours}h",
  commonDaysAgo: "hace %{days}d",
  commonFollowing: "siguiendo",
  commonFollowers: "seguidores",

  // Empty / error states
  emptyProfilesTitle: "Sin perfiles para mostrar",
  emptyProfilesBody: "Aún no has agregado perfiles para monitorear.",
  errorGenericTitle: "Algo salió mal",
  errorGenericBody: "Ocurrió un error inesperado. Inténtalo de nuevo.",
  errorNetworkTitle: "Problema de conexión",
  errorNetworkBody: "Verifica tu conexión a internet e inténtalo de nuevo.",

  // Login
  loginBackToHome: "← Volver al inicio",
  loginWelcomeBack: "Bienvenido de nuevo",
  loginSubtitle: "Inicia sesión para ver tus perfiles monitoreados, cambios recientes y alertas.",
  loginEmailLabel: "Correo electrónico",
  loginEmailPlaceholder: "tu@ejemplo.com",
  loginSendingCode: "Enviando código...",
  loginContinueBtn: "Continuar con correo electrónico",
  loginFooterNote: "Usa el mismo correo electrónico conectado a tu aplicación Stalkie. Te enviaremos un código único, sin necesidad de contraseña.",
  loginBack: "Atrás",
  loginCheckEmail: "Revisa tu correo electrónico",
  loginSentCodeTo: "Enviamos un código de 6 dígitos a",
  loginLoggingIn: "Iniciando sesión...",
  loginResendCode: "Reenviar código",
  loginSendAgain: "Enviar de nuevo",
  loginNeedHelp: "¿Necesitas ayuda?",
  loginContactSupport: "Contactar al soporte",
  loginErrorSend: "No pudimos enviar tu código. Revisa tu correo e intenta de nuevo.",
  loginErrorVerify: "Ese código no funcionó. Revisa el código e intenta de nuevo.",
  loginErrorResend: "No se pudo reenviar. Intenta de nuevo.",
  loginSubmitBtn: "Iniciar sesión",

  // 404
  notFoundTitle: "Esta página no existe.",
  notFoundGoHome: "Volver al inicio",

  // Parity / Dossier keys
  dossierTitle: "Detalles del Perfil",
  dossierMutual: "Se siguen mutuamente",
  dossierFollowers: "Seguidores",
  dossierFollowing: "Seguidos",
  dossierPrivate: "Perfil Privado",
  dossierPublic: "Perfil Público",
  dossierViewOnInstagram: "Ver en Instagram",
  genderBreakdownTitle: "Análisis de género de los follows",
  genderBreakdownText: "Siguió recientemente: %{female} chicas, %{male} chicos, %{unknown} otros",
  genderBreakdownFemale: "%{count} chicas",
  genderBreakdownMale: "%{count} chicos",
  genderBreakdownUnknown: "%{count} otros",
  genderBreakdownNone: "Ningún follow detectado aún",
  mutualBadge: "Mutuo",
  dossierCategoryPersonal: "Cuenta Personal",
  dossierCategoryInfluencer: "Influenciador",
  dossierCategoryCreator: "Creador",
  dossierCategoryBrand: "Marca / Empresa",
};

export default es;
